'use client';
import React from "react";
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import '../tools/ToolsPage.css'

const Impressum = () => {
    return (
        <>
            <Header />
            <div className="tools-container">
                <h2 className="privacy-policy-title mb-2">Impressum</h2>
                <div className="effective-date">Information in accordance with § 5 TMG (Telemedia Act) / § 5 DDG (Digital Services Act)</div>
                <h4 className="section-title" id="section-title">Operator of the website:</h4>
                <div className="section-content">
                    <p>Husali Technologies Pvt. Ltd.</p>
                </div>

                <h4 className="section-title" id="section-title">Legal Form:</h4>
                <div className="section-content">
                    <p>Private Limited Company</p>
                </div>

                <h4 className="section-title" id="section-title">Registered Address:</h4>
                <div className="section-content">
                    <p>F 401, Madhuvishwa Society, <br />
                        Bavdhan, Pune - 411021,<br />
                        India</p>
                </div>

                <h4 className="section-title" id="section-title">Contact:</h4>
                <div className="section-content">
                    <p>Email: <a href="mailto:contact@munichindians.com" className="husali">contact@munichindians.com</a></p>
                </div>

                <h4 className="section-title" id="section-title">Registration Details:</h4>
                <div className="section-content">
                    <p>Registered with the Ministry of Corporate Affairs (MCA) in India.<br/>
                        Corporate Identity Number (CIN): U72900PN2020PTC195031</p>
                </div>

                <h4 className="section-title" id="section-title">Represented by:</h4>
                <div className="section-content">
                    <p>Sadashiv Laxman Patil</p>
                </div>

                <h4 className="section-title" id="section-title">VAT Identification Number (India):</h4>
                <div className="section-content">
                    <p>GSTIN: 27AAFCH4919P1ZZ</p>
                </div>


            </div>
            <Footer />
        </>
    );
}

export default Impressum;